import { faTrashAlt } from '@fortawesome/pro-solid-svg-icons';
import { FC, useEffect } from 'react';
import { useDeleteContact } from 'src/apis/organisation-service/use-delete-contact';
import { Modal } from 'src/components/overlay/modal';
import { useCountdown } from 'src/hooks/use-countdown';
import { useToast } from 'src/hooks/use-toasts';

type Props = {
  close: () => void;
  onSuccess: () => void;
  deleteContactUrl: string;
};

export const DeleteContactModal: FC<Props> = ({
  close,
  onSuccess,
  deleteContactUrl,
}) => {
  const seconds = useCountdown();
  const notify = useToast();
  const deleteContact = useDeleteContact();

  useEffect(() => {
    if (!deleteContact.response) return;

    notify({
      type: 'success',
      children: 'Contact deleted successfully.',
    });
    onSuccess();
    close();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [deleteContact.response]);

  return (
    <Modal
      title="Delete Contact"
      icon={faTrashAlt}
      onDismiss={close}
      footer={{
        confirmButton: {
          label: seconds
            ? `Wait ${seconds}s to proceed...`
            : deleteContact.pending
              ? 'Pending...'
              : 'Delete Contact',
          onClick: () => deleteContact.execute(deleteContactUrl),
          dataTestId: seconds === 0 ? 'delete-submit' : undefined,
          disabled: deleteContact.pending || seconds !== 0,
        },
      }}
    >
      <p>Please confirm that you want to delete this contact.</p>
    </Modal>
  );
};
